// extracted by mini-css-extract-plugin
export default {"select":"CommunityMultiSelect_select__Fys63","ant-select":"CommunityMultiSelect_ant-select__pRveF","ant-select-selector":"CommunityMultiSelect_ant-select-selector__Jpozb"};